module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('p', {
    staticClass: "ptb10"
  }, [_vm._v("1、地图")]), _vm._v(" "), _c('el-amap', {
    staticClass: "amap-demo",
    attrs: {
      "vid": "amapDemo1",
      "zoom": _vm.zoom,
      "center": _vm.center
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ptb10"
  }, [_vm._v("2、点坐标")]), _vm._v(" "), _c('el-amap', {
    staticClass: "amap-demo",
    attrs: {
      "vid": "amapDemo2",
      "zoom": _vm.zoom,
      "center": _vm.center
    }
  }, _vm._l((_vm.markers), function(marker) {
    return _c('el-amap-marker', {
      key: marker.position,
      attrs: {
        "position": marker.position
      }
    })
  }), 1), _vm._v(" "), _c('p', {
    staticClass: "ptb10"
  }, [_vm._v("3、多边形")]), _vm._v(" "), _c('el-amap', {
    staticClass: "amap-demo",
    attrs: {
      "vid": "amapDemo3",
      "zoom": _vm.zoom,
      "center": _vm.center3
    }
  }, _vm._l((_vm.polygons), function(polygon, index) {
    return _c('el-amap-polygon', {
      key: index,
      ref: ("polygon_" + index),
      refInFor: true,
      attrs: {
        "vid": index,
        "path": polygon.path,
        "events": polygon.events
      }
    })
  }), 1), _vm._v(" "), _c('p', {
    staticClass: "pt10"
  }, [_vm._v("4、搜索")]), _vm._v(" "), _c('div', {
    staticClass: "amap-page-container"
  }, [_c('el-amap-search-box', {
    staticClass: "search-box",
    attrs: {
      "search-option": _vm.searchOption,
      "on-search-result": _vm.onSearchResult
    }
  }), _vm._v(" "), _c('el-amap', {
    staticClass: "amap-demo",
    attrs: {
      "vid": "amapDemo4",
      "zoom": _vm.zoom,
      "center": _vm.center4
    }
  }, _vm._l((_vm.markers4), function(marker) {
    return _c('el-amap-marker', {
      key: marker.position,
      attrs: {
        "position": marker
      }
    })
  }), 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c4a1dca4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/views/demo/amap.vue
// module id = 902
// module chunks = 0